module.exports = __webpack_public_path__ + "static/img/info03@2x.7cbb1831.png";